import React, {useEffect, useState} from "react";
import {Modal, Row, Steps, notification} from "antd";
import Step1FilledData from './step-1-filled-data';
import StepCheckingAndEditVerifiedInfo from './step-checking-and-edit-verified-info';
import Step5SendingInfo from './step-5-sending-info';
import './attach-driver-order-delivery.css';
import '../modals.css';
import {driverService, trailService, truckService, systemService, orderDeliveryService, userServices} from "../../../services";
import i18n from "i18next";
import RedirectModal from "../redirect-modal";
import ModalSelectCarrierLegalEntity from "../select-carrier-legal-entity";

export default function ModalAttachDriverOrderDelivery({
    orderId, companyId, isShow, setIsShow, setNeedUpdateDeliveryList,
    setStopListUpdate,
    deliveryDateShipmentRus,
    deliveryPrice,
    deliveryRegionLoad,
    deliveryRegionUnload,
    isForeignDelivery,
    deliveryContractType,
    deliveryId,
    date,
    permissions,
    delivery
}) {

    const [currentStep, setCurrentStep] = useState(1);
    const [contentStep, setContentStep] = useState(null);
    const [buttonsModal, setButtonsModal] = useState([]);
    const [carryingCapacityValues, setCarryingCapacityValues] = useState(null);
    const [loading, setLoading] = useState(false);

    const [showSelectCarrierLegalEntityModal, setSelectCarrierLegalEntityModal] = useState(false);
    const [redirectText, setRedirectText] = useState('');
    const [showRedirectModal, setShowRedirectModal] = useState(false);
    const [redirectRoute, setRedirectRoute] = useState('');

    const [filledData, setFilledData] = useState({
        selectedDriver: null,
        selectedTruck: null,
        selectedTrail: null,
        isTrailDisabled: true,
        dateProcuration: null,
        numberProcuration: null,
        withoutProcuration: false,
        selectedForeignPartner: null,
        containerNumber: null,
    });

    useEffect(() => {
        if (isShow && loading) {
            systemService.getCarryingCapacity()
                .then((response) => {
                    setLoading(false);
                    setCarryingCapacityValues(response);
                })
                .catch((error) => {
                    setLoading(false);
                    notification.error({
                        message: i18n.t('components.notification.titles.getCarryingCapacity'),
                        description: error,
                    });
                });
            orderDeliveryService
                .start(orderId)
                .then((response) => {
                    if(response.status === "error" && response.errorType) {
                        const user = userServices.getUser();

                        if (user.info.userType === 'carrier') {
                            if (response.errorType === "need_shipper_contract") {
                                setSelectCarrierLegalEntityModal(true);
                            } else if (response.errorType === "need_check_contract_state") {
                                setRedirectRoute("/company/orders-to-shipper-company");
                                setRedirectText(response.message);
                                setShowRedirectModal(true);
                            }
                        } else {
                            setRedirectRoute("");
                            setRedirectText("Перед заполнением заявки перевозчик должен заключить договор с грузоотправителем");
                            setShowRedirectModal(true);
                        }
                    }
                })
                .catch((error) => {
                    notification.error({
                        message: i18n.t('components.notification.titles.startFillOrder'),
                        description: error
                    });
                });
        }
    }, [isShow, loading]);


    useEffect(() => {
        if (isShow && !loading){
            setLoading(true);
        }
    }, [isShow]);


    const onCloseModal = () => {
        setIsShow(false);
        setNeedUpdateDeliveryList(true);
        setStopListUpdate(false);
    };

    useEffect(() => {

        switch (currentStep) {
            default:
            case 1:
                setContentStep(
                    <Step1FilledData
                        companyId={companyId}
                        filledData={filledData}
                        setFilledData={setFilledData}
                        setIsShowModal={setIsShow}
                        showModal={isShow}
                        setButtonsModal={setButtonsModal}
                        currentModalStep={currentStep}
                        setModalStep={setCurrentStep}
                        deliveryDateShipmentRus={deliveryDateShipmentRus}
                        deliveryPrice={deliveryPrice}
                        deliveryRegionLoad={deliveryRegionLoad}
                        deliveryRegionUnload={deliveryRegionUnload}
                        isForeignDelivery={isForeignDelivery}
                        carryingCapacityValues={carryingCapacityValues}
                        onCloseModal={onCloseModal}
                        deliveryContractType={deliveryContractType}
                    />
                );
                break;

            case 2:
                setContentStep(
                    <StepCheckingAndEditVerifiedInfo
                        key={currentStep}
                        id={filledData.selectedDriver}
                        setButtonsModal={setButtonsModal}
                        currentModalStep={currentStep}
                        setModalStep={setCurrentStep}
                        onCheckingRequest={driverService.checkVerifiedInfo}
                        onSaveEditingInfoRequest={driverService.saveEditingInfo}
                        onCloseModal={onCloseModal}
                        loadingMessage={i18n.t('modals.modalAttachDriverOrderDelivery.step2.loadingMessage')}
                    />
                );
                break;

            case 3:
                setContentStep(
                    <StepCheckingAndEditVerifiedInfo
                        key={currentStep}
                        id={filledData.selectedTruck}
                        driverId={filledData.selectedDriver}
                        setButtonsModal={setButtonsModal}
                        currentModalStep={currentStep}
                        setModalStep={setCurrentStep}
                        onCheckingRequest={truckService.checkVerifiedInfo}
                        onSaveEditingInfoRequest={truckService.saveEditingInfo}
                        loadingMessage={i18n.t('modals.modalAttachDriverOrderDelivery.step3.loadingMessage')}
                        carryingCapacityValues={carryingCapacityValues}
                        onCloseModal={onCloseModal}
                    />
                );
                break;

            case 4:
                setContentStep(
                    <StepCheckingAndEditVerifiedInfo
                        key={currentStep}
                        id={filledData.selectedTrail}
                        driverId={filledData.selectedDriver}
                        setButtonsModal={setButtonsModal}
                        currentModalStep={currentStep}
                        setModalStep={setCurrentStep}
                        onCheckingRequest={trailService.checkVerifiedInfo}
                        onSaveEditingInfoRequest={trailService.saveEditingInfo}
                        loadingMessage={i18n.t('modals.modalAttachDriverOrderDelivery.step4.loadingMessage')}
                        carryingCapacityValues={carryingCapacityValues}
                        isNeedChecking={(!filledData.isTrailDisabled)}
                        onCloseModal={onCloseModal}
                    />
                );
                break;

            case 5:
                setContentStep(
                    <Step5SendingInfo
                        key={currentStep}
                        orderId={orderId}
                        filledData={filledData}
                        setButtonsModal={setButtonsModal}
                        currentModalStep={currentStep}
                        setModalStep={setCurrentStep}
                        onCloseModal={onCloseModal}
                        deliveryId={deliveryId}
                        date={date}
                        permissions={permissions}
                    />
                );
                break;

            case 6:
                setContentStep(<div/>);
                break;
        }

    }, [isShow, currentStep, filledData]);

    if (currentStep === 6){
        onCloseModal();
    }

    return (
        <>
        <Modal
            title={i18n.t('modals.modalAttachDriverOrderDelivery.title')}
            cancelText={i18n.t('main.buttons.close')}
            className="modal-window"
            align={null}
            visible={isShow}
            onCancel={onCloseModal}
            footer={buttonsModal}
        >
            <Row>
                <Steps type="navigation" size="small" current={currentStep - 1} className="site-navigation-steps" style={{marginBottom: "14px"}}>
                    <Steps.Step title={i18n.t('modals.modalAttachDriverOrderDelivery.step1.title')}/>
                    <Steps.Step title={i18n.t('modals.modalAttachDriverOrderDelivery.step2.title')}/>
                    <Steps.Step title={i18n.t('modals.modalAttachDriverOrderDelivery.step3.title')}/>
                    <Steps.Step title={i18n.t('modals.modalAttachDriverOrderDelivery.step4.title')}/>
                    <Steps.Step title={i18n.t('modals.modalAttachDriverOrderDelivery.step5.title')}/>
                </Steps>
            </Row>
            <Row className="modal-attach-driver__steps-content">
                {contentStep}
            </Row>
        </Modal>
        <ModalSelectCarrierLegalEntity
            isShow={showSelectCarrierLegalEntityModal}
            setIsShow={setSelectCarrierLegalEntityModal}
            delivery={delivery}
            setNeedUpdateDeliveryList={setNeedUpdateDeliveryList}
            setStopListUpdate={setStopListUpdate}
            initLegalEntity={delivery.Order.LegalEntity ? delivery.Order.LegalEntity.Id : null}
        />
        <RedirectModal
            isShow={showRedirectModal}
            setIsShow={setShowRedirectModal}
            route={redirectRoute}
            text={redirectText}
            setNeedUpdateDeliveryList={setNeedUpdateDeliveryList}
        />
        </>
    );
}
